var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9911 10L13.152 12.8391C13.0348 12.9563 12.9688 13.1155 12.9688 13.2812C12.9688 13.2913 12.969 13.3013 12.9695 13.3113C12.9769 13.4665 13.0419 13.6133 13.1518 13.7232C13.269 13.8404 13.428 13.9062 13.5938 13.9062C13.7595 13.9062 13.9185 13.8404 14.0357 13.7232L17.3169 10.4419C17.4342 10.3247 17.5 10.1658 17.5 10C17.5 9.83424 17.4342 9.67527 17.3169 9.55806L14.0358 6.27688C13.9185 6.1596 13.7595 6.09375 13.5938 6.09375C13.428 6.09375 13.269 6.1596 13.1518 6.27681C13.0346 6.39402 12.9688 6.55299 12.9688 6.71875C12.9688 6.88451 13.0346 7.04348 13.1518 7.16069L15.9911 10Z",
    fill: "#303335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10.625H16.875C17.2202 10.625 17.5 10.3452 17.5 10C17.5 9.65482 17.2202 9.375 16.875 9.375H8.125C7.77982 9.375 7.5 9.65482 7.5 10C7.5 10.3452 7.77982 10.625 8.125 10.625Z",
    fill: "#303335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75H8.125C8.47018 3.75 8.75 3.47018 8.75 3.125C8.75 2.77982 8.47018 2.5 8.125 2.5H3.75C3.23223 2.5 2.86612 2.86612 2.86612 2.86612C2.5 3.23223 2.5 3.75 2.5 3.75V16.25C2.5 16.7678 2.86612 17.1339 2.86612 17.1339C3.23223 17.5 3.75 17.5 3.75 17.5H8.125C8.47018 17.5 8.75 17.2202 8.75 16.875C8.75 16.5298 8.47018 16.25 8.125 16.25H3.75V3.75Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/signOutIcon.b40bbf41e24cee3e011015d6e58a850d.svg";
export { ForwardRef as ReactComponent };